import React from 'react';
import { WidgetContextProvider } from 'widgets/WidgetContext';
import { useDelayedHover } from '@instinet-analytics/core-lib';
import './Widget.scss';
import { WidgetComponentProps } from 'widgets/WidgetComponentProps';
import { WidgetId } from 'widgets/WidgetId';
import { WidgetHost } from 'widgets/WidgetRegistry';
import classNames from 'classnames';
import { useWidgetTabTitleOutsideContext } from 'widgets/tabTitle/hooks';
import { useWidgetsService } from 'widgets/hooks';

export interface WidgetProps extends WidgetComponentProps, WidgetId {
    host: WidgetHost;
    component: React.FC<WidgetComponentProps>;
    width: number;
    height: number;
}

/*
 * Component within which each widget will be rendered
 */
export default function Widget(props: WidgetProps) {
    const {
        host,
        widgetKey,
        widgetType,
        width,
        height,
        onSetTitle,
        component: WidgetComponent,
    } = props;

    const [onMouseEnter, onMouseLeave, isHovering] = useDelayedHover(0);
    const widgetsService = useWidgetsService();

    useWidgetTabTitleOutsideContext(
        widgetsService,
        widgetType,
        widgetKey,
        onSetTitle
    );

    const cssClasses = classNames('Widget', `host-${host}`);

    return (
        <div
            className={cssClasses}
            data-widget-key={widgetKey}
            data-widget-type={widgetType}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <WidgetContextProvider
                widgetKey={widgetKey}
                widgetType={widgetType}
                host={host}
                width={width}
                height={height}
                isHovering={isHovering}
            >
                <WidgetComponent onSetTitle={onSetTitle} />
            </WidgetContextProvider>
        </div>
    );
}
